var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"component-wrap"},[_c('Events')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }